"use client";

import { Api } from "@/app/api";
import type { Basket } from "@/types";

export const basketApiInjection = Api.injectEndpoints({
	overrideExisting: true,
	endpoints: (builder) => ({
		getBasketMe: builder.query<Basket, void>({
			query: () => ({ url: "/baskets/me" }),
			providesTags: ["basket"],
			extraOptions: { maxRetries: 0 },
		}),
		putBasketMe: builder.mutation<Basket, Basket>({
			query: (body) => ({
				url: "/baskets/me",
				method: "PUT",
				// Only send the DTO shape — never extra client-only fields.
				body: { items: body?.items ?? {} },
			}),
			invalidatesTags: ["basket"],
		}),
		deleteBasketMe: builder.mutation<{ items: Record<string, never> }, void>({
			query: () => ({
				url: "/baskets/me",
				method: "DELETE",
			}),
			invalidatesTags: ["basket"],
		}),
	}),
});

export const {
	useGetBasketMeQuery,
	useLazyGetBasketMeQuery,
	usePutBasketMeMutation,
	useDeleteBasketMeMutation,
} = basketApiInjection;
